export default __webpack_public_path__ + "static/media/navbar-ring-tour.ea4b6973.svg";